import { render } from "./modaladditem.vue?vue&type=template&id=9b8bb778"
import script from "./modaladditem.vue?vue&type=script&lang=js"
export * from "./modaladditem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__